(function () {

  function initAmbassadorDashboard() {

    var dashboard =
      document.querySelector('.ambassador-dashboard');

    if (!dashboard) return;

    /*
     * Prevent the dashboard from being initialized
     * more than once when Custlo updates the page.
     */
    if (dashboard.getAttribute('data-ambassador-initialized') === 'true') {
      return;
    }

    dashboard.setAttribute(
      'data-ambassador-initialized',
      'true'
    );


    var customerId =
      dashboard.getAttribute('data-customer-id');

    var loadingEl =
      dashboard.querySelector('#ambassador-loading');

    var errorEl =
      dashboard.querySelector('#ambassador-error');

    var contentEl =
      dashboard.querySelector('#ambassador-dashboard-content');


    if (!customerId) {

      if (loadingEl) {
        loadingEl.style.display = 'none';
      }

      if (errorEl) {
        errorEl.textContent =
          'We could not identify your customer account.';

        errorEl.style.display = 'block';
      }

      return;
    }


    var params =
      new URLSearchParams();

    params.append(
      'shopify_customer_id',
      customerId
    );


    fetch(
      'https://netsaviapps.com/ssd/ambassador-account.asp',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/x-www-form-urlencoded; charset=UTF-8',

          'Accept':
            'application/json'
        },

        body: params.toString()
      }
    )

    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Network response was not ok'
        );
      }

      return response.json();

    })

    .then(function (data) {

      if (loadingEl) {
        loadingEl.style.display = 'none';
      }


      if (!data || !data.success) {

        if (errorEl) {

          errorEl.textContent =
            data && data.message
              ? data.message
              : 'We could not load your ambassador account.';

          errorEl.style.display = 'block';
        }

        return;
      }


      /* =========================
         SUMMARY CARDS
         ========================= */

      setText(
        dashboard,
        '#ambassador-code',
        data.ambassador_code || '—'
      );

      setText(
        dashboard,
        '#approved-sales',
        formatMoney(data.approved_sales)
      );

      setText(
        dashboard,
        '#pending-sales',
        formatMoney(data.pending_sales)
      );

      setText(
        dashboard,
        '#store-credit',
        formatMoney(data.available_store_credit)
      );

      setText(
        dashboard,
        '#lifetime-credit',
        formatMoney(data.lifetime_credit_earned)
      );

      setText(
        dashboard,
        '#next-reward',
        data.next_reward_text || '—'
      );

      setText(
        dashboard,
        '#next-milestone',
        data.next_milestone_text || ''
      );


      /*
       * Credit carryover
       */

      var carryover =
        parseFloat(
          data.credit_carryover || 0
        );

      var carryoverEl =
        dashboard.querySelector(
          '#credit-carryover'
        );

      if (carryoverEl) {

        if (carryover > 0) {

          carryoverEl.textContent =
            formatMoney(carryover) +
            ' carried toward your next $20 credit';

        } else {

          carryoverEl.textContent = '';

        }

      }


      /* =========================
         REFERRAL ORDERS
         ========================= */

      var ordersBody =
        dashboard.querySelector(
          '#ambassador-orders-body'
        );


      if (ordersBody) {

        if (
          !data.orders ||
          !data.orders.length
        ) {

          ordersBody.innerHTML =
            '<tr>' +
              '<td colspan="4" class="ambassador-empty">' +
                'No referral orders yet.' +
              '</td>' +
            '</tr>';

        } else {

          ordersBody.innerHTML =
            data.orders.map(
              function (order) {

                var statusClass =
                  String(
                    order.status || ''
                  ).toLowerCase();

                return (
                  '<tr>' +

                    '<td>' +
                      escapeHtml(
                        order.order_number || ''
                      ) +
                    '</td>' +

                    '<td>' +
                      escapeHtml(
                        order.customer || ''
                      ) +
                    '</td>' +

                    '<td>' +
                      formatMoney(
                        order.sale_amount
                      ) +
                    '</td>' +

                    '<td>' +
                      '<span class="ambassador-status ' +
                        escapeHtml(
                          statusClass
                        ) +
                      '">' +
                        escapeHtml(
                          order.status || ''
                        ) +
                      '</span>' +
                    '</td>' +

                  '</tr>'
                );

              }
            ).join('');

        }

      }


      /* =========================
         CREDIT HISTORY
         ========================= */

      var creditHistoryBody =
        dashboard.querySelector(
          '#ambassador-credit-history-body'
        );


      if (creditHistoryBody) {

        if (
          !data.credit_history ||
          !data.credit_history.length
        ) {

          creditHistoryBody.innerHTML =
            '<tr>' +
              '<td colspan="4" class="ambassador-empty">' +
                'No credit activity yet.' +
              '</td>' +
            '</tr>';

        } else {

          creditHistoryBody.innerHTML =
            data.credit_history.map(
              function (item) {

                var status =
                  item.status || '';

                var statusClass =
                  String(status)
                    .toLowerCase();

                var amount =
                  parseFloat(
                    item.amount || 0
                  );

                var formattedAmount =
                  (
                    amount > 0
                      ? '+'
                      : ''
                  ) +
                  formatMoney(amount);


                return (
                  '<tr>' +

                    '<td>' +
                      escapeHtml(
                        item.date || ''
                      ) +
                    '</td>' +

                    '<td>' +
                      escapeHtml(
                        item.description || ''
                      ) +
                    '</td>' +

                    '<td class="' +
                      (
                        amount > 0
                          ? 'ambassador-credit-positive'
                          : ''
                      ) +
                    '">' +
                      formattedAmount +
                    '</td>' +

                    '<td>' +
                      '<span class="ambassador-status ' +
                        escapeHtml(
                          statusClass
                        ) +
                      '">' +
                        escapeHtml(
                          status
                        ) +
                      '</span>' +
                    '</td>' +

                  '</tr>'
                );

              }
            ).join('');

        }

      }


      if (contentEl) {
        contentEl.style.display = 'block';
      }


      initAmbassadorTabs(
        dashboard
      );

    })

    .catch(function (error) {

      console.error(
        'Ambassador dashboard error:',
        error
      );

      if (loadingEl) {
        loadingEl.style.display = 'none';
      }

      if (errorEl) {

        errorEl.textContent =
          'Sorry, something went wrong while loading your ambassador account.';

        errorEl.style.display = 'block';
      }

    });

  }



  /* =========================
     TAB HANDLING
     ========================= */

  function initAmbassadorTabs(
    dashboard
  ) {

    dashboard
      .querySelectorAll(
        '.ambassador-tab-btn'
      )
      .forEach(
        function (button) {

          if (
            button.getAttribute(
              'data-tab-initialized'
            ) === 'true'
          ) {
            return;
          }

          button.setAttribute(
            'data-tab-initialized',
            'true'
          );


          button.addEventListener(
            'click',
            function () {

              var targetId =
                button.getAttribute(
                  'data-tab'
                );


              dashboard
                .querySelectorAll(
                  '.ambassador-tab-btn'
                )
                .forEach(
                  function (btn) {

                    btn.classList.remove(
                      'is-active'
                    );

                    btn.setAttribute(
                      'aria-selected',
                      'false'
                    );

                  }
                );


              dashboard
                .querySelectorAll(
                  '.ambassador-tab-panel'
                )
                .forEach(
                  function (panel) {

                    panel.classList.remove(
                      'is-active'
                    );

                  }
                );


              button.classList.add(
                'is-active'
              );

              button.setAttribute(
                'aria-selected',
                'true'
              );


              var targetPanel =
                dashboard.querySelector(
                  '#' + targetId
                );

              if (targetPanel) {

                targetPanel.classList.add(
                  'is-active'
                );

              }

            }
          );

        }
      );

  }



  /* =========================
     HELPERS
     ========================= */

  function setText(
    dashboard,
    selector,
    value
  ) {

    var element =
      dashboard.querySelector(
        selector
      );

    if (element) {
      element.textContent = value;
    }

  }


  function formatMoney(value) {

    var number =
      parseFloat(
        value || 0
      );

    return '$' +
      number.toFixed(2);

  }


  function escapeHtml(value) {

    return String(value)

      .replace(
        /&/g,
        '&amp;'
      )

      .replace(
        /</g,
        '&lt;'
      )

      .replace(
        />/g,
        '&gt;'
      )

      .replace(
        /"/g,
        '&quot;'
      )

      .replace(
        /'/g,
        '&#039;'
      );

  }



  /* =========================
     INITIAL PAGE LOAD
     ========================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAmbassadorDashboard
    );

  } else {

    initAmbassadorDashboard();

  }



  /* =========================
     CUSTLO DYNAMIC PAGE LOAD
     ========================= */

  var ambassadorObserver =
    new MutationObserver(
      function () {

        if (
          document.querySelector(
            '.ambassador-dashboard'
          )
        ) {

          initAmbassadorDashboard();

        }

      }
    );


  ambassadorObserver.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();